import { useGetMeQuery } from "@/redux/feature/user/userApi";
import { useAppSelector } from "@/redux/hooks/hooks";
import { TUser } from "@/types/types";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

// Define the context type properly
type GlobalContextType = {
  userData: TUser;
  isUserLoading: boolean;
};

// Create a NotificationContext with a default empty object
const GlobalContext = createContext<GlobalContextType | null>(null);

export const GlobalContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  // User data
  const { user, token } = useAppSelector((state) => state.auth);
  const { data, isLoading, isFetching } = useGetMeQuery(user?.email);
  const isUserLoading = isLoading || isFetching;
  const userData = data?.data as TUser;
  return (
    <GlobalContext.Provider
      value={{
        userData,
        isUserLoading,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook to use notifications
export const useGlobalContext = () => {
  const context = useContext(GlobalContext);

  if (!context) {
    throw new Error("useGlobal must be used within a GlobalContextProvider");
  }

  return context;
};
